import React from 'react';
import { motion } from 'framer-motion';
import './MerchCard.css';

const MerchCard = ({ title, image, price }) => {
  return (
    <motion.div
      className="merch-card"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <div className="merch-image-wrapper">
        <img src={image} alt={title} className="merch-image" />
      </div>
      <div className="merch-info">
        <h3>{title}</h3>
        <p>${price}</p>
      </div>
    </motion.div>
  );
};

export default MerchCard;
